import SearchParamsBase from '../../../Elements/SearchParamsBase';
import InputTypesEnum from '../../../Enums/InputTypesEnum';

export default class SurveyTransferAnswerOptionRulesSearchParams extends SearchParamsBase {
  initialize() {
    // The parent question-mapping scope is injected by the page (from the ?id= url param);
    // it is not a visible search field.
    this.SurveyTransferQuestionMappingId = '';
    this.TargetAnswerOptionText = '';
    this.SourceAnswerOptionText = '';
  }

  static iconName = 'fa-solid fa-search';
  static saveType = 'SurveyTransferAnswerOptionRulesSearchParams';

  static fieldsInSearchBox = [
    { fieldName: 'TargetAnswerOptionText', label: 'Target Answer Text', className: 'col-4', type: InputTypesEnum.Text },
    { fieldName: 'SourceAnswerOptionText', label: 'Source Answer Text', className: 'col-4', type: InputTypesEnum.Text },
  ];

}
